module.exports = __webpack_public_path__ + "assets/img/flag-task-rewrite.319da12e.svg";